module.exports = __webpack_public_path__ + "img/icon_process1.7d7acf32.png";